import { IdentifiableDto } from "./identifiable.dto";

export class EditMappableRadiusDto {
    radius: number;
}